import { render, staticRenderFns } from "./CHeaderBn.vue?vue&type=template&id=619d5e0d&scoped=true&"
import script from "./CHeaderBn.vue?vue&type=script&lang=js&"
export * from "./CHeaderBn.vue?vue&type=script&lang=js&"
import style0 from "./CHeaderBn.vue?vue&type=style&index=0&id=619d5e0d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d5e0d",
  null
  
)

export default component.exports